import type { RouteLocationRaw, RouteRecordRaw } from "vue-router";
import {customAsyncComponent} from "@/functions/customAsyncComponent";
import {LOCALE_CATEGORIES} from "@/assets/locales/categories.ts";

export function getTermsOfServiceRouteRecord():RouteRecordRaw{
  return {
    name: 'tos',
    path: '/terms-of-service',
    component: customAsyncComponent(async () => import('./views/TermsOfServiceView.vue')),
    meta: {
      noAuth: true,
      localeCategories: [
        LOCALE_CATEGORIES.TOS_GLOBAL,
        //LOCALE_CATEGORIES.MY_ACCOUNT,
        LOCALE_CATEGORIES.ERRORS
      ]
    },
  }
}

export function getTermsOfServiceRouteLocation():RouteLocationRaw{
  return { name: 'tos'}
}